import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import { AdesaoService } from 'src/app/services/adesao.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { ChangeDetectorRef } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { ReactiveFormsModule } from '@angular/forms';
declare var $: any;

@Component({
    selector: 'app-adesao-termos-aceites',
    templateUrl: './adesao-termos-aceites.component.html',
    styleUrls: ['./adesao-termos-aceites.component.css'],
    imports: [ReactiveFormsModule]
})
export class AdesaoTermosAceitesComponent implements OnInit {

  stateValue: string = "";
  usercpf: string = "";
  check: boolean = false;
  nameError: boolean = false;
  sobrenomeError: boolean = false;
  asppError: string = "";

  @Input() parentForm: FormGroup;
  public menorDeIdade: boolean;

  @ViewChild("isnotnull", { read: ElementRef, static: true })
  isnotnull: ElementRef;

  isNotNull: boolean = false;
  tipoRepresentante:any[]=[];
  cpfRep:boolean = false;

  nifForm: FormGroup = null;

  newopt: any = false;

  tiponedisabled: any = true;
  tiptwodisabled: any = true;
  tipthreedisabled: any = true;


  btnlock: any = true;
  nifs: any = [];
  nacionalidades: any[] = [];
  tiposVinculo: any[] = [];
  parentescos:any[] = [];
  instituidores:any[] = [];
  value: string;
  codInstituidor: number;
  codVinculo: number;
  decMostraVinculo: number;
  cpfAssociado:boolean = false;



  userbirth: any = {
    tab: "three",
  };


  public constructor(private adesao: AdesaoService, private toastr: ToastrService,private  autenticacao:AutenticacaoService, private cdr: ChangeDetectorRef, private utilService: UtilService) { }


  ngOnInit() {
    this.listarTiposDeVinculo();
    this.listaParentesco();
    this.listaInstituidores();
    this.listarTipoRepresentante();
    this.nifForm = new FormGroup({
      numNIF: new FormControl(null, [Validators.required]),
      dcrNacionalidade: new FormControl("", [Validators.required])

    });

    this.listaPais();

  }

  setMenorDeIdade(menorDeIdade: boolean){

    this.menorDeIdade = menorDeIdade;

  }

  onUserCpfChange(stateValue: string): void {
    let cpfTit = this.autenticacao.getCredenciais().cpf;

    if (this.utilService.verifyCpf(stateValue)) {

      if(stateValue !== cpfTit){
        this.parentForm.get('representante.cpfRep').setValue(stateValue.replace(/\./g, "").replace(/\-/g, ""));
        this.parentForm.get('representante.cpfRepIsValid').clearValidators();
        this.parentForm.get('representante.cpfRepIsValid').reset();
      }else{
        this.cpfRep = true;
      }

    }else{
      this.parentForm.get('representante.cpfRepIsValid').setValidators([Validators.requiredTrue]);
      this.parentForm.get('representante.cpfRepIsValid').reset();
      this.cpfRep = false;
    }
  }

  listarTipoRepresentante(){

    this.adesao.ListarTipoRep()
    .subscribe(
      (res:any)=>{
        this.tipoRepresentante = res;
      }
    )
  }


  salvarRepresentante(){
    this.adesao.salvarRepresentante(this.parentForm.get("representante").value)
    .subscribe(
      ()=>{



      },
      (httpError: HttpErrorResponse)=>{
        this.toastr.error(httpError.error.ex);
      }
    )
  }

  listaPais() {
    this.adesao.ListarNacionalidades()
      .subscribe(
        (res: any) => {
          this.nacionalidades = res;
        }
      )
  }

  incluirNif() {
    this.adesao.salvarNif(this.nifForm.value)
      .pipe(
        finalize(() => { })
      )
      .subscribe(
        (res: any) => {
          this.parentForm.get('termos.nifok').setValue(true);
          this.listarNif();
          this.limpaCampos();
        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
          this.parentForm.get('termos.nifok').setValue(false);
        }
      )
  }

  listarNif() {

    this.value = this.parentForm.get("termos.idcPais").value
    this.adesao.listarNif()
      .subscribe(
        (res: any) => {
          this.nifs = res;

          if (res.length > 0) {
            this.newopt = true;
            this.parentForm.get('termos.idcPais').setValue('S');
            this.parentForm.get('termos.nifok').setValue(true);
          } else {
            if (this.value === "S") {
              this.newopt = true;
              this.parentForm.get('termos.nifok').setValue(false);
            } else {
              this.newopt = false;
              this.parentForm.get('termos.nifok').setValue(true);
            }

          }
        },
        (httpError: HttpErrorResponse) => {
          this.parentForm.get('termos.nifok').setValue(false);
        }
      )
  }

  removeNIF(dcrNif) {
    this.adesao.removerNif(dcrNif)
      .subscribe(
        () => {
          this.listarNif();
        },
        (httpError: HttpErrorResponse) => {
          this.parentForm.get('termos.nifok').setValue(false);
        }
      )
  }



  verificaResidenciaFiscal(value) {

    this.value = value;
    if (value === "S") {
      this.newopt = true;
      this.parentForm.get('termos.nifok').setValue(false);
      this.nifForm.controls['numNIF'].setValue("");
      this.nifForm.controls['codPais'].setValue("");

    } else {
      let this2 = this;
      if (this.nifs.length > 0) {
        this.nifs.forEach(function (item) {
          this2.removeNIF(item.DCR_NACIONALIDADE);
        })
      }
      this.newopt = false;
      this.parentForm.get('termos.nifok').setValue(true);
    }
  }

  OncodInstituidorChange(event, codVinculo) {

    this.codVinculo = codVinculo;

    let selectedIndex: number = event.target["selectedIndex"];
    this.codInstituidor = event.target.options[selectedIndex].getAttribute("data-cod_instituidor");
    this.decMostraVinculo = event.target.options[selectedIndex].getAttribute("data-dec_mostra_vinculo");

    this.parentForm.get('vinculo.decMostraVinculo').setValue(this.decMostraVinculo);

    this.parentForm.get('vinculo.codInstituidor').setValue(this.codInstituidor);
    this.parentForm.get('vinculo.codVinculo').setValue(this.codVinculo);

    this.parentForm.get('vinculo.cpfAssociado').reset();
    this.parentForm.get('vinculo.cpfIsValid').reset();
    this.parentForm.get('vinculo.nomeAssociado').reset();
    this.parentForm.get('vinculo.sobrenomeAssociado').reset();
    this.parentForm.get('vinculo.CodParentescoAssociado').reset();

    this.parentForm.get('termos.decInstituidor').setValue("N");

    if (this.codInstituidor == 1) {
      $('#modalTermoAbrapp').modal('show');
    } else if (this.codInstituidor == 2) {
      $('#modalTermoAfa').modal('show');
    }else if(this.codInstituidor == 3){
      $('#modalTermoASPP').modal('show');
    }
  }

  onUserCPFChange(stateValue: string): void {
    let cpfTit =  this.autenticacao.getCredenciais().cpf;

    if (this.utilService.verifyCpf(stateValue)) {

      if(stateValue !== cpfTit){
        this.cpfAssociado = false;
        this.parentForm.get("vinculo.cpfAssociado").setValue(stateValue.replace(/\./g, "").replace(/\-/g, ""))
        this.parentForm.get("vinculo.cpfIsValid").clearValidators();
        this.parentForm.get("vinculo.cpfIsValid").reset();
      }else{
        this.cpfAssociado = true;
        this.parentForm.get("vinculo.cpfIsValid").setValidators([Validators.requiredTrue]);
        this.parentForm.get("vinculo.cpfIsValid").reset();
      }

    }else{
      this.parentForm.get("vinculo.cpfIsValid").setValidators([Validators.requiredTrue]);
      this.parentForm.get("vinculo.cpfIsValid").reset();
      this.cpfAssociado = false;
    }

  }



  onUserCheckChange(natValue: boolean): void {


    if(!natValue){
      this.parentForm.get("vinculo.idcTermoVinculo").setValue('N');
    }else{
      this.parentForm.get("vinculo.idcTermoVinculo").setValue('S');
    }

  }

  listarTiposDeVinculo() {

    this.adesao.ListarTiposDeVinculo()
      .subscribe(
        (res: any) => {
          this.tiposVinculo = res;
        }
      )

  }


  listaParentesco(){
    this.adesao.ListarParentesco()
    .subscribe(
      (res:any)=>{
        this.parentescos = res;
      }
    )
  }

  listaInstituidores(){
    this.adesao.ListarInstituidores()
    .subscribe(
      (res:any)=>{

        this.instituidores = res;
      }
    )
  }




limpaCampos(){
  this.nifForm.controls["numNIF"].setValue(null);
  this.nifForm.controls["codPais"].setValue(null);
  this.nifForm.controls["dcrPais"].setValue(null);
}

openOneModal() {
  this.tiponedisabled = false;
  this.tiptwodisabled = true;
}

openTwoModal() {
  this.tiptwodisabled = false;
  this.tiponedisabled = true;
}

openthreeModal(){
  this.tipthreedisabled = false;
  this.tiptwodisabled = true;
}

closeOneModal() {
  this.tiponedisabled = true;
}

closeTwoModal() {
  this.tiptwodisabled = true;
}

closeThreeModal(){
  this.tipthreedisabled = true;
}


}
